export default __webpack_public_path__ + "static/media/640_portfolio04-en-web.bb181f0d.png";